import DesignNavigationItem from "../../../../visComponents/designNavigationItem";
import {IntermediatePart} from "../../parts/intermediatePart";
import {Shower} from "../../parts/shower";
import {LayoutAbbreviation} from "../../constants";
import {ShowerTubCombo} from "../../parts/showerTubCombo";

export default class PonyWall extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'pony_wall';
    this.isPonyWallPart = true;
    this.visible = true;
    this.partName = 'Pony Wall';
    this.translateId = "visualizer.bathroom.walls.pony_wall";
    this.isStoneFeature = true;
    this.disableOnHomeSections = true;
    this.shadowName = "Pony Wall";
    this.activeFeatureBeforeAllWalls = null;
  }

  load(dbFeature) {
    return super.load_(dbFeature, new PonyWall());
  }

  disabledClick() {

  }

  handleClick(ignoreLocked, clickFrom) {
    super.handleClick(ignoreLocked);

    const wallParent = this.getParent().getParent();

    const layout = wallParent.layout;
    const layoutAbr = layout.getCurrentLayoutAbbreviation();

    if (layoutAbr === LayoutAbbreviation.Large) {
      if (clickFrom !== 'context' && clickFrom !== 'all_walls') {
        const wallExLFeature = wallParent.wallExL && wallParent.wallExL.features.find(feature => {
          return feature.partName === this.partName
        });
        if (wallExLFeature) {
          wallExLFeature.handleClick(ignoreLocked, 'context');
        }
      }
    }

    this.featureClicked();
  }

  setZIndex(zIndexes) {
    const zIndex = zIndexes.Shower.Custom60in.PonyWall;
    const zIndex2 = zIndexes.Shower.Custom60in.PonyWallShadow;
    if (zIndexes && this.activeFeature) {
      this.activeFeature.layer.zIndex = zIndex;
    }
    if (zIndexes && this.placeholderFeature) {
      this.placeholderFeature.layer.zIndex = zIndex;
    }
    if (zIndexes && this.shadowFeature) {
      this.shadowFeature.layer.zIndex = zIndex2;
    }
  }

  getAvailableFeatures(filters) {
    const filteredAvailableFeatures = super.getFilteredFeaturesByFilters(filters);
    return super.navigationSubItemsWithFilterMultipleConditions(this.getArrayOfConditions(), filteredAvailableFeatures);
  }

  navigationSubItems(filters, searchText) {
    const filteredAvailableFeatures = super.getFeaturesBySearchText(super.getFilteredFeaturesByFilters(filters), searchText);
    const featuresToDisplay = super.navigationSubItemsWithFilterMultipleConditions(this.getArrayOfConditions(), filteredAvailableFeatures);
    return featuresToDisplay.map(_ => new DesignNavigationItem(_.featureName, _));
  }

  setLayers(layout) {
    const shower = this.getParent().layout.parts[Shower.id];
    const showerParent = shower.getActiveShowerGroup();
    if (showerParent.showerDimensions() !== "Pony" || (!shower.showerTubComboIsActive()
        && shower.showerBody.disabled)) {
      super.hideLayers();
      return;
    }

    if (!this.shadowFeature
      || (this.shadowFeature && !this.shadowFeature.matchesMetaForArrayOfConditions(this.getArrayOfConditions()))) {
      this.setShadowFeature();
    }

    if (this.activeFeature && (this.activeFeature.matchesMetaForArrayOfConditions(this.getArrayOfConditions())
        || (this.activeFeature.notAvailableInVisualizer && this.placeholderFeature))) {
      return super.setLayers(layout);
    }

    this.setDefault(layout);
    return super.setLayers(layout);
  }

  getArrayOfConditions() {
    const parent = this.getParent();
    const layout = parent.layout;
    const layoutAbr = layout.getCurrentLayoutAbbreviation();
    if (layoutAbr === LayoutAbbreviation.Small){
      const activeShower = parent.showerTubComboIsActive()
        ? layout.parts[ShowerTubCombo.id]
        : layout.parts[Shower.id];
      const showerSize = activeShower.showerSize(); // 60in, 30in, ..
      // const showerDimensions = activeShower.showerDimensions(); // 15x4, Pony, ...
      return [{
        propName: 'Shower',
        propValue: 'Custom'
      }, {
        propName: 'Size',
        propValue: showerSize
      }];
    }

    return []
  }

  setDefault(layout) {
    if (!layout)
      return ;

    const layoutAbr = layout.getCurrentLayoutAbbreviation();
    const filteredFeatures = this.features.filter(f => f.matchesMetaForArrayOfConditions(this.getArrayOfConditions()));
    if (!super.tryToSetTheSameFeature(filteredFeatures, null, null, true)) {
      let hardCodedName = '';
      switch (layoutAbr) {
        case LayoutAbbreviation.Small:
          hardCodedName = 'Pony Wall - Demo Model';
          break;
        case LayoutAbbreviation.Large:
          hardCodedName = 'Pony Wall - Model[For=Shower=(Custom)=Size=(30in_60in)]';
          break;
        default:
          console.error('PonyWall - Unknown Layout Abr', layoutAbr);
      }

      const hardCodedDefault = filteredFeatures.find((feature) => {
        return feature.dbFeature.displayName &&
          feature.dbFeature.displayName.includesCI(hardCodedName);
      });
      const placeholderDefault = filteredFeatures.find((feature) => {
        return feature.dbFeature.displayName && feature.dbFeature.displayName.includesCI("placeholder");
      });
      this.activeFeature = hardCodedDefault || filteredFeatures[0];
      this.placeholderFeature = placeholderDefault || null;
      this.setShadowFeature();
    }
  }

  // changeLayout(layoutType) {
  changeLayout() {
    // this.activeFeature = null;
  }
}
